import { connect, ConnectedProps } from 'react-redux';
import { BillingOption } from '../../../../../../../../shared/utils/billing-options';
import { RootState } from '../../../../../../../../store/root-reducer';
import PlansSection from './plans-section';

const mapStateToProps = (state: RootState) => ({
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionRequest.status,
  sendGetInboxAnalyzerSubscriptionResponse:
    state.billingAndSubscription.getInboxAnalyzerSubscriptionResponse,
  sendGetInboxAnalyzerPlansResponse:
    state.billingAndSubscription.getInboxAnalyzerPlansResponse,
  sendPurchaseInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest
      .status,
  sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerModifySubscriptionRequest
      .status,
  isDemoAccount: state?.home?.isDemoAccount,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  onSelectPlan: (planId: number, planName: string) => void;
  planCycle: BillingOption;
  selectedPlanId: number;
  isPaddlePolling?: boolean;
};

export default connector(PlansSection);
